// extracted by mini-css-extract-plugin
export var actions = "_2x-0";
export var actionsContainer = "_2x-7";
export var border = "_2x-1";
export var childFullHeight = "_2x-f";
export var collapse = "_2x-2";
export var content = "_2x-a";
export var contentChild = "_2x-e";
export var fullscreen = "_2x-c";
export var hasLeftRadius = "_2x-k";
export var headerContainer = "_2x-3";
export var headerRow = "_2x-5";
export var hidePadding = "_2x-b";
export var navCollapsedGap = "_2x-l";
export var noScrollX = "_2x-m";
export var noScrollY = "_2x-n";
export var noTopPadding = "_2x-i";
export var optOutTopPadding = "_2x-d";
export var pageMain = "_2x-j";
export var pageOuter = "_2x-g";
export var pagePadding = "_2x-8";
export var pageScroll = "_2x-9";
export var profile = "_2x-o";
export var profileContainer = "_2x-p";
export var profileImage = "_2x-q";
export var profileMain = "_2x-r";
export var profileSubtitle = "_2x-t";
export var profileTitle = "_2x-s";
export var showLeftPadding = "_2x-h";
export var tabsPortalSlot = "_2x-6";
export var tabsWrapper = "_2x-4";
export var title = "_2x-u";